import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function usePayinsList() {
  // Use toast
  const toast = useToast()

  const refPayinListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    // { key: 'id', label: '#', sortable: true },
    // { key: 'msisdn', label: 'Customer Phone', sortable: true },
    { key: 'full_name', label: 'Customer', sortable: true },
    { key: 'amount', sortable: true, formatter: val => `KES${val}` },
    { key: 'transaction_id', label: 'Transaction ID' },
    { key: 'transaction_ref', label: 'Bill Ref No.', formatter: title },
    { key: 'timestamp', sortable: true, label: 'Transaction Time' },
    { key: 'status', label: 'Status', sortable: true },
  ]
  const perPage = ref(10)
  const totalPayins = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const isBusy = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refPayinListTable.value ? refPayinListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPayins.value,
    }
  })

  const refetchData = () => {
    refPayinListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchPayins = (ctx, callback) => {
    isBusy.value = true
    store
      .dispatch('payments/fetchPayins', {
        search: searchQuery.value,
        page_size: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data, paginator } = response.data
        callback(data)
        isBusy.value = false
        totalPayins.value = paginator.length
      })
      .catch(() => {
        isBusy.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching payins' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolvePayinStatusVariantAndIcon = status => {
    if (status === 'pending') return { variant: 'warning', icon: 'PieChartIcon' }
    if (status === 'processed') return { variant: 'success', icon: 'CheckCircleIcon' }
    if (status === 'failed') return { variant: 'danger', icon: 'XIcon' }
    return { variant: 'secondary', icon: 'XIcon' }
  }
  const resolveClientAvatarVariant = status => {
    return 'primary'
  }

  return {
    fetchPayins,
    tableColumns,
    perPage,
    currentPage,
    totalPayins,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPayinListTable,

    statusFilter,
    isBusy,

    resolvePayinStatusVariantAndIcon,
    resolveClientAvatarVariant,
    refetchData,
  }
}
